<template>
    <div class="event-actions">

    <div
      class="event-add__photo"
      :title="'Добавить фото'"
    >
      <input
          class="image-loader"
          type="file"
          multiple
          @change="loadPhoto"
          name="translation-photo"
          max-size="10000"
          accept="image/*"
          title="Загрузить фото"
        />
      <p>Добавить фото</p>
      <img src="@/assets/images/icons/events/icon_add-photo.svg" />
    </div>
    <div
      class="event-edit"
      @click="more = !more"
    >
      <font-awesome-icon icon="ellipsis-h" />
      <div class="dropdown" v-if="more">
        <div class="dropdown-item" v-if="!isAuthor" @click="$emit('setComplain', {place_id: place.id, type: 'place'})">
          <font-awesome-icon icon="exclamation-triangle" />
          <p>Пожаловаться</p>
        </div>
        <div class="dropdown-item" v-if="isAuthor" @click="editPlace()">
          <font-awesome-icon icon="pencil-alt" />
          <p>Редактировать</p>
        </div>
        <div class="dropdown-item" v-if="isAuthor" @click="$emit('deletePlace')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path
              d="M17 22H7a2 2 0 01-2-2V7H3V5h4V4a2 2 0 012-2h6a2 2 0 012 2v1h4v2h-2v13a2 2 0 01-2 2zM7 7v13h10V7H7zm2-3v1h6V4H9zm6 14h-2V9h2v9zm-4 0H9V9h2v9z"
            />
          </svg>
          <p>Удалить</p>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
export default {
    name: 'placePanel',
    data: () => {
        return {
            more: false
        }
    },
    props: {
        place: {
            type: Object,
            require: true
        },
        isAuthor: {
            type: Boolean,
            require: true
        }
    },
    methods: {
        async editPlace() {
            let place = this.place;
            await this.$store.dispatch('editPlace', place)
            this.place.sports.forEach(element => {
                this.$store.dispatch('changeSportsNew', element)
            })
        },
        addPhoto(url) {
            this.$axios.post('api/places/media/add', {url, place_id: this.place.id})
            .then(res => {
                console.log(res, 'res');
                this.$store.dispatch('addNotification', {message: 'Ваше фото успешно добавлено в трансляцию!'})
            })
            .catch(error => {
                console.log(error,'error');
                this.$store.dispatch('addError', {message: 'Не удалось загрузить фото'})
            })
        },
        loadPhoto(input) {
            let files = input.target.files;
            files.length > 10
                ? this.$store.dispatch('addError', {
                    message: 'Максимум 10 фотографий',
                })
                : '';
            files.forEach(async (element, index) => {
                if (index < 10) {
                if (element.size / 1024 > 10000) {
                    this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 10MB'});
                } else {

                    var reader = new FileReader();
                    reader.readAsDataURL(element)
                    reader.onload = async () => {
                    let url = reader.result;
                    let type = element.type.split('/')[1];
                    let size = element.size / 1024;
                    let path = "places_photos";
                    let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
                    this.place.photos.unshift({
                        url: null,
                        key: null
                    });
                    let index = 0;
                    await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path}).then(response => {
                        response.Location 
                            ? (this.place.photos[index].url = response.Location, this.place.photos[index].key = response.key) 
                            : (this.place.photos.splice(index, 1), this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'}));
                        this.addPhoto(response.Location)
                    }).catch(() => {
                        this.place.photos.splice(index, 1);
                        this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                    });
                    };

                    reader.onerror = function() {
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                    };
                    
                    
                }
                }
            });
        },
    }
}
</script>